import apiClient from "../vue/http/axios";

const notProfile = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'

async function getLocations(data) {
  const resp = await apiClient.post(`locations/get_all_company_locations`, {data});
  const items = [{id: null, name: `General`}]
  items.push(...resp.data.data.map(item => ({id: item.id, name: item.name})));
  return items;
}

async function getUsers() {
  const users = await apiClient.get('approved_user/index_approvers_with_names');
  return [{ id: null, name: 'Todos' }, ...users.data.data];
}

async function getGeneralStats(params) {
  const response = await apiClient.get('invited_client/index_invited_stats', {params});
  return {
    approved: response.data.approved_invitations,
    created: response.data.created_invitations,
    denied: response.data.deny_invitations,
    invitationAccess: response.data.used_invitations,
    averageTime: '15:00',
  };
}

async function getInvitationTypesStats(params) {
  
  const resp = await apiClient.get('invited_client/invitations_by_invited_type_status', {params});
  return resp.data.data ?? [];
}

async function getApproversStats(params) {
  const resp = await apiClient.get('approved_user/index_approver_stats',  {params});

  return (resp.data.data ?? []).map(item => ({
    photo: item.picture ?? notProfile,
    name: item.name,
    approved: item.approved_count,
    denied: item.denied_count,
    id: item.id,
    averageApproval: '02:22 min'
  }));
}

async function getDenialStats(params) {  
  const resp = await apiClient.get('approved_user/index_approver_stats', {params});
  return (resp.data.data ?? []).filter(item => item.denied_count > 0).map(item => ({
    photo: item.picture ?? notProfile,
    name: item.name,
    denied: item.denied_count,
    id: item.id,
  }));
}

async function getYearlyStats() {
  const resp = await apiClient.get('invited_client/index_annual_invitations');
  return resp.data.data;
}

async function getDeniedSpecificStats(params) {
  const resp = await apiClient.get('approved_user/denial_reasons_summary', {params});
  return (resp.data.data ?? []).map(item => ({
    id: item.id,
    name: item.name,
    quantity: item.count,
  }));
}

async function getTopInvitations(params) {

  const resp = await apiClient.get('invited_client/index_top_invitations', {params});
  return (resp.data.data ?? []).map((item, index) => {

    const numberArray = monthMapper(item.count_per_month)
    return {
      id: index,
      inviterName: item.data_inviter.name,
      inviterPhoto: item.data_inviter.picture ?? notProfile,
      invitedName: item.data_invitation.name,
      invitedPhoto: item.data_invitation.photo ?? notProfile,
      quantity: item.total_count,
      counter: numberArray,
      greatter: Math.max(...numberArray),
      averageApproval: ' 03:22:10'
   } 
  });
}

const monthMapper = (monthArray = []) => {
  const monthOrderMap = new Map()
    .set('January', 1)
    .set('February', 2)
    .set('March', 3)
    .set('April', 4)
    .set('May', 5)
    .set('June', 6)
    .set('July', 7)
    .set('August', 8)
    .set('September', 9)
    .set('October', 10)
    .set('November', 11)
    .set('December', 12);

  
  const monthsCounter = [];

  monthOrderMap.keys().forEach(key => {
    monthsCounter.push(monthArray.find(item => item.month === key)?.count ?? 0);
  });
  return monthsCounter;
}

export default {
  getLocations,
  getUsers,
  getGeneralStats,
  getInvitationTypesStats,
  getApproversStats,
  getDenialStats,
  getYearlyStats,
  getDeniedSpecificStats,
  getTopInvitations,
}